/* eslint-disable no-unused-vars */
/* eslint no-use-before-define: 0 */
import * as Sentry from "@sentry/react";
// libraries
import classNames from "classnames";
import { useCallback, useEffect, useState } from "react";
import React from "react";
// constants
import { useTranslation } from "react-i18next";

// types
import { PaymentBrand } from "../../../setup/api/services/payment/models";
import { verifyPinCode } from "../../../setup/api/services/user";
import { AuthConfig } from "../../../setup/context/config/authConfig";
import { browserName } from "../../../setup/util/checkBrowser";
// components
import PrimaryButton, { PrimaryButtonType } from "../../common/PrimaryButton";
import PaymentForm from "./paymentForm";
import PaymentPin from "./paymentPin";
// styles
import styles from "./styles.module.scss";

declare global {
  interface Window {
    wpwl: unknown;
  }
}

interface Props {
  checkoutId: string;
  contractId: string;
  handleCheckout: (payment: PaymentBrand) => void;
  dataForAmpli: any;
  disabled: boolean;
}

const PaymentMethods = ({
  checkoutId,
  contractId,
  handleCheckout,
  dataForAmpli,
  disabled,
}: Props): JSX.Element => {
  const userInfo = AuthConfig.getUserInfo();
  const { t } = useTranslation();
  const [error, setError] = useState<string>();
  const [open, setOpen] = useState(false);

  const [pinVerified, setPinVerified] = useState(false);

  const [selected, setSelected] = useState<PaymentBrand>(PaymentBrand.NONE);

  useEffect(() => {
    setOpen(open);
  }, [open]);

  const handlePinVerified = useCallback(
    async (pincode: string) => {
      try {
        setError(undefined);
        const body = { pinCode: pincode };
        if (userInfo) {
          const result = await verifyPinCode(userInfo?.id, body);
          if (result?.data?.valid) {
            setPinVerified(true);
          } else {
            setPinVerified(false);
            setError(t("lbl_verify_pin_code_error"));
          }
        }
      } catch (error) {
        Sentry.captureException(error);
        console.error(error);
        setPinVerified(false);
        setError(t("lbl_verify_pin_code_error"));
      }
    },
    [t, userInfo]
  );

  if (checkoutId === "") {
    return (
      <div dir="rtl" className={styles.paymentMethodsContainer}>
        <h4>{t("lbl_pay_contract_no_payment_method_title")}</h4>
        <div className={"mt2"}>
          <div
            onClick={() => setSelected(PaymentBrand.MADA)}
            className={classNames(
              styles.methodContainer,
              selected === PaymentBrand.MADA && styles.selected
            )}>
            <img src="/assets/images/svg/mada.svg" alt="" />
            <p
              className={classNames(
                "subtitle2",
                selected === PaymentBrand.MADA && "primary"
              )}>
              {" "}
              {t("lbl_pay_contract_mada_method")}
            </p>
          </div>
          <div
            onClick={() => setSelected(PaymentBrand.VISA)}
            className={classNames(
              styles.methodContainer,
              selected === PaymentBrand.VISA && styles.selected
            )}>
            <img src="/assets/images/svg/visa.svg" alt="" />
            <p
              className={classNames(
                "subtitle2",
                selected === PaymentBrand.VISA && "primary"
              )}>
              {" "}
              {t("lbl_pay_contract_visa_method")}
            </p>
          </div>
          {browserName === "Safari" && (
            <div
              onClick={() => setSelected(PaymentBrand.APPLEPAY)}
              className={classNames(
                styles.methodContainer,
                selected === PaymentBrand.APPLEPAY && styles.selected
              )}>
              <img src="/assets/images/svg/apple-pay.svg" alt="" />
              <p
                className={classNames(
                  "subtitle2",
                  selected === PaymentBrand.APPLEPAY && "primary"
                )}>
                {" "}
                {t("lbl_pay_apple_pay")}
              </p>
            </div>
          )}
          <PrimaryButton
            id={`contract_details_payment_modal_confirm_card`}
            onClick={() => handleCheckout(selected)}
            buttonType={
              selected === PaymentBrand.NONE
                ? PrimaryButtonType.DISABLED
                : PrimaryButtonType.DEFAULT
            }
            disabled={selected === PaymentBrand.NONE || disabled}>
            {t("lbl_slider_add_bank_btn")}
          </PrimaryButton>
        </div>
      </div>
    );
  }

  // if (!pinVerified)
  //   return <PaymentPin handleSubmit={handlePinVerified} error={error} />;

  return (
    <div dir="rtl" className={styles.paymentMethodsContainer}>
      <PaymentForm
        checkoutId={checkoutId}
        contractId={contractId}
        dataForAmpli={dataForAmpli}
        paymentBrand={selected}
      />
    </div>
  );
};

export default PaymentMethods;
